import { cn } from "@/modules/lib/utils"
import { TemplateWeekCalendar } from "@/modules/template/components/calendar/templateWeekCalendar"

type TemplateWeekViewProps = {
  templateId: string
  className?: string
} & React.ComponentProps<"div">

export function TemplateWeekView({ templateId, className, ...props }: TemplateWeekViewProps) {
  return (
    <div className={cn("flex flex-1 flex-col gap-4 px-1", className)} {...props}>
      <TemplateWeekCalendar templateId={templateId} mode="preview" />
    </div>
  )
}
